// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2Bj-M","selected":"Chip_selected__zYmBa"};